import styled from 'styled-components';

export const LedgerTableLayout = styled.div`
  display: grid;
  margin: 0 32px;
`;

export const LedgerTableFooter = styled.div`
  height: 32px;
`;

export const EmptyElement = styled.div`
  height: 1px;
`;
